<template>
    <div id="open-button" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="goBackward">Назад</div>
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="openDesign">Товары</div>
    </div>
</template>

<script>
    export default {
        name: "RightLowerBarOpenResultDesign",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            adjacentSteps() {
                let stepsOrder = this.$store.state.UI.stepsChain[this.version].stepsOrder
                return stepsOrder[this.activeStep]
            }
        },
        methods: {
            openDesign() {
                this.$router.push({name: this.adjacentSteps.next}).catch(() => {})
            },
            goBackward() {
                this.$router.push({name: this.adjacentSteps.prev}).catch(() => {})
            }
        }
    }
</script>

<style scoped>

</style>
